if (typeof window !== 'undefined') {
    window.$ = window.jQuery = require('jquery')
}
